/**
 * @typedef {import('./AdminResponse').Props} Props
 * @typedef {import('./AdminResponse').State} State
 */

import { translate } from '../../../Internationalization';
import AdminTable from '../../shared/AdminTable';
import FormSuccessMessages from '../../../../shared/Forms/Messages/FormSuccessMessages';
import images from '../../../../config/local/images';
import LinkButton from '../../../../shared/LinkButton';
import paths from '../../../../config/local/paths';
import React from 'react';
import SearchFilter from '../../../shared/Query/Filters/Search/SearchFilter';

/** @extends {React.Component<Props, State>} */
export default class ViewAdmins extends React.Component {
	/**
	 * @param {Props} props
	 */
	constructor(props) {
		super(props);

		/**
		 * @type {State}
		 */
		this.state = {
			isRefreshingData: false,
			searchQuery: '',
			searchResetKey: 0,
			totalRecord: 0,
		};

		this._handleSubmitSearch = this._handleSubmitSearch.bind(this);
		this._setIsRefreshingData = this._setIsRefreshingData.bind(this);
		this._setTotalRecords = this._setTotalRecords.bind(this);
	}

	/**
	 * @param {{[key: string]: string}} value
	 * @returns {void}
	 */
	_handleSubmitSearch(value) {
		const nextSearchQuery =
			value?.['search[email]']?.trim() ??
			value?.['search[name.first]']?.trim() ??
			'';

		if (nextSearchQuery === this.state.searchQuery) {
			return;
		}

		this.setState((prevState) => ({
			searchQuery: nextSearchQuery,
			searchResetKey:
				nextSearchQuery === ''
					? prevState.searchResetKey + 1
					: prevState.searchResetKey,
		}));
	}

	/**
	 * @protected
	 * @param {boolean} isRefreshingData
	 * @returns {void}
	 */
	_setIsRefreshingData(isRefreshingData) {
		this.setState({ isRefreshingData });
	}

	/**
	 * @protected
	 * @param {number} number
	 * @returns {void}
	 */
	_setTotalRecords(number) {
		this.setState({
			totalRecord: number,
		});
	}

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		return (
			<React.Fragment>
				<header className="mt-10 mb-6 md:flex justify-between items-center">
					<h1 className="hl-ms-6 mb-6 md:mb-0">
						{`${translate('admin.pages.admins.view.title')} (${
							this.state.totalRecord
						})`}
					</h1>
					<LinkButton
						icon={images.icons.plus}
						to={paths.app.admin.admins.add}
					>
						{translate('admin.pages.admins.view.add')}
					</LinkButton>
				</header>
				<FormSuccessMessages
					messages={this.props.location?.state?.message}
				/>
				<section className="mb-6 flex justify-end">
					<SearchFilter
						disabled={this.state.isRefreshingData}
						key={this.state.searchResetKey}
						onSubmit={this._handleSubmitSearch}
						query={
							this.state.searchQuery
								? {
										'search[email]': this.state.searchQuery,
										'search[name.first]':
											this.state.searchQuery,
										'search[name.last]':
											this.state.searchQuery,
								  }
								: {}
						}
						search={['email', 'name.first', 'name.last']}
					/>
				</section>
				<AdminTable
					// @ts-ignore -- declared
					searchQuery={this.state.searchQuery}
					setIsRefreshingData={this._setIsRefreshingData}
					setTotalRecord={this._setTotalRecords}
				/>
			</React.Fragment>
		);
	}
}
